import React from 'react';

import TemplateImg from '../../../assets/images/no-template.svg';
const TemplateEmpty = () => {
  return (
    <div className="emptyState">
      <div className="no-template">
        <img src={TemplateImg} alt="" />
        <h4>No template selected</h4>
        <p>Please select a template to view its details here.</p>
      </div>
    </div>
  );
};

export default TemplateEmpty;
